import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { CallbackService } from '@callback/data-access';
import { CallbackFormComponent } from '../phone-modal/callback-form.component';

@Component({
  selector: 'sd-design-request-modal',
  templateUrl: './design-request-modal.component.html',
  styleUrls: ['./design-request-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CallbackFormComponent],
})
export class DesignRequestModalComponent implements OnDestroy {
  constructor(private callbackService: CallbackService) {}

  ngOnDestroy(): void {
    this.callbackService.resetProcess();
  }
}
